export default "__VITE_ASSET__DJAYz2st__"